//GeneratorFlag:[NoChange]
import ProductSeo from './product-seo';

export default {ProductSeo}
export{ProductSeo}